export default {
  login: {
    title: 'Log in to your account.',
    mail: 'Mail',
    password: 'Password',
    button: {
      confirm: 'Login',
      forgot: 'Forgot my password'
    },
    dialog: {
      notfound: {
        title: 'Unauthorized access',
        text: 'User or password incorrect',
        confirm: 'OK'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes. If the problem persists contact technical assistance.',
        confirm: 'OK'
      }
    },
    rules: {
      mail_required: 'E-mail is required',
      mail_valid: 'E-mail must be valid',
      password_required: 'Password is required'
    }
  },
  register: {
    title: 'Register',
    mail: 'Mail',
    terms_text: 'Terms and conditions.',
    terms_check: 'I accept terms of use and privacity policy.',
    privacy_text: 'Privacity policy.',
    privacy_check: 'I accept privacity policy.',
    button: {
      confirm: 'Register'
    },
    dialog_contract: {
      terms: 'Terms and conditions',
      privacy: 'Privacy policy',
      close: 'Close'
    },
    dialog: {
      confirm: {
        title: 'Welcome',
        text: 'Confirm your email.',
        confirm: 'OK'
      },
      exists: {
        title: 'User exists!',
        text: 'This name or mail is registered.',
        confirm: 'OK'
      },
      noverifytoken: {
        title: 'reCaptcha Problem!',
        text: "We can't verify Captcha",
        confirm: 'OK'
      },
      invaliddata: {
        title: 'Invalid data',
        text: 'Please verify register fields.',
        confirm: 'OK'
      },
      invalidtoken: {
        title: 'Invalid captcha',
        text: "We can't verify Captcha.",
        confirm: 'OK'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes. If the problem persists contact technical assistance.',
        confirm: 'OK'
      }
    },
    rules: {
      mail_required: 'Mail is required',
      mail_valid: 'Mail must be valid',
      terms_check: 'You need accept use conditions',
      privacy_check: 'You need accept privacy polices'
    }
  },
  forgot: {
    title: 'Request a new password',
    mail: 'Mail',
    button: {
      confirm: 'Request password'
    },
    dialog: {
      confirm: {
        title: 'Account recuperation',
        text: 'Your mail recuperation is been sent',
        confirm: 'OK'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes. If the problem persists contact technical assistance.',
        confirm: 'OK'
      }
    }
  },
  users_panel: {
    input_label: 'Find user',
    id: 'Id',
    mail: 'Mail',
    firstname: 'Name',
    lastname: 'Lastname',
    id_card: 'ID Card',
    address: 'Adress',
    postal_code: 'Postal Code',
    city: 'City',
    country: 'Country',
    created_at: 'Fecha Alta',
    status: {
      title: 'Status',
      inactive: 'Inactive',
      active: 'Active',
      block: 'Block'
    },
    no_data: 'No data available',
    activeworkersdigital: 'Rq News',
    activeworkersyoutube: 'Rq Yout',
    activeworkersinstagram: 'Wk Inst',
    activeworkersfacebook: 'Wk Face',
    activeworkerstwitter: 'Wk Twit',

    activeworkersdigitalmax: 'Rq News MAX',
    activeworkersyoutubemax: 'Rq Yout MAX',
    activeworkersinstagrammax: 'Wk Inst MAX',
    activeworkersfacebookmax: 'Wk Face MAX',
    activeworkerstwittermax: 'Wk Twit MAX'
  },
  footer: {
    text: 'All rights reserved',
    copy: 'Trawlingweb.com'
  },
  client_dashboard: {
    title: 'Services Overview',
    estadisticas: 'Statistics',
    latest: 'Latest 10 Request',
    token: 'APIS',
    sitebar: {
      title: 'Description:',
      description: 'Get an at-a-glance understanding of your services, current usage, and available resources.',

      sub_title_01: 'Key Points:',
      sub_description_01: '',

      li_01_title_01: 'Configured Services:',
      li_01_text_01: 'Each API line represents a specific service (e.g., News, YouTube).',

      li_01_title_02: 'Requests Remaining:',
      li_01_text_02: 'Shows how many requests you can still make for that service.',

      li_01_title_03: 'Tokens:',
      li_01_text_03: 'Your unique access key for each service. Keep it secret.',

      li_01_title_04: 'Workers:',
      li_01_text_04: 'Resources working for that service. Watch the count!',

      li_01_title_05: 'Upgrade:',
      li_01_text_05: 'Need more queries or workers? Hit "Upgrade" to discuss options with our upgrade team.',

      tips_title: 'Tip:',
      tips_description: 'Monitor "Request remaining" to avoid overuse and ensure uninterrupted service.'
    }
  },
  statistics: {
    title: 'Statistics',
    consumed: 'Consumed',
    latest: 'Latest request',
    token: 'Services',
    sitebar: {
      title: 'Description:',
      description: 'This section provides an overview of your consumption patterns and the recent requests made to the APIs.',

      sub_title_01: 'Key Points:',
      sub_description_01: '',

      li_01_title_01: 'Consumed Requests:',
      li_01_text_01: 'Visual chart showing daily requests across different services.',

      li_01_title_02: 'Latest 10 Request:',
      li_01_text_02: 'A real-time log of the last 10 API calls with details such as date, IP, service, user agent, and the actual request payload.',

      tips_title: 'Tip:',
      tips_description:
        "Review this section regularly to monitor your service usage and ensure you're making the most of the platform. Spot any anomalies or irregular patterns to optimize your consumption."
    }
  },
  playground: {
    title: 'Playground',
    subtitle: 'Try API',
    title_digital: 'News',
    title_youtube: 'YouTube',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_law: 'Legal',
    title_newspro: 'News Pro',
    title_tiktok: 'TikTok',
    search_query: 'Introduce search expression',
    worker_selected: 'Select a Worker',
    hint_search: 'use expressions with the format explained in documentation, in Searching expressions section',
    results: 'Results',
    list: ' (100 results shown)',
    list_10: ' (10 results shown)',
    list_50: ' (50 results shown)',
    get_results: 'Search!',
    request_remaining: 'searches remaining',
    format: 'Format',
    order: 'Priority order capture',
    direction: 'Date order',
    time: 'Time',
    date_limit: 'date: start',
    date_limit_range: 'date: end',
    modeviewer: 'Modos',
    modeweb: 'WEB',
    modejson: 'JSON',
    modetable: 'TABLE',
    new_view: {
      title: 'Title: ',
      url: 'URL: ',
      rack: 'Alexa Rank:',
      published: 'Published: ',
      published_by: 'Site: ',
      language: 'Language: ',
      site_country: 'Country: ',
      site_type: 'Type: ',
      author: 'Author: ',
      rank: 'Rank: ',
      unique_visitors: 'Visitors: ',
      value: 'Value: ',
      site_language: 'Language:',
      read_more: '... read more'
    },
    law_view: {
      title: 'Title: ',
      url: 'URL: ',
      published: 'Published: ',
      published_by: 'Site: ',
      language: 'Language: ',
      site_country: 'Country: ',
      site_type: 'Type: ',
      read_more: '... read more'
    },
    youtube_view: {
      title: 'Title: ',
      published: 'Published: ',
      url: 'URL: ',
      description: 'Description: ',
      channel: 'Channel: ',
      language: 'Language: ',
      views: 'Views: ',
      likes: 'Likes: ',
      dislikes: 'Dislikes: ',
      favourites: 'Favourites: ',
      comments: 'Comments: '
    },
    instagram_view: {
      published: 'Published: ',
      type: 'Type: ',
      likes: 'Likes: ',
      dislikes: 'Dislikes: ',
      user_name: 'User Name: ',
      screen_name: 'Screen Name: ',
      publications: 'Publications: ',
      followers: 'Followers: ',
      followed: 'Followed: ',
      favourites: 'Favourites: ',
      comments: 'Comments: ',
      text: 'Text: ',
      url: 'URL: '
    },
    facebook_view: {
      published: 'Published: ',
      type: 'Type: ',
      likes: 'Likes: ',
      user_name: 'User Name: ',
      screen_name: 'Name: ',
      publications: 'Publications: ',
      shared: 'Shared: ',
      comments: 'Comments: ',
      url: 'URL: '
    },
    twitter_view: {
      published: 'Published: ',
      location: 'Location: ',
      site: 'Site: ',
      retweet: 'Retweet? ',
      retweets: 'Retweeted: ',
      reply_count: 'Replies: ',
      quote_count: 'Quoteds: ',
      favourite_count: 'Favourites: ',
      user_name: 'User Name: ',
      screen_name: 'Screen Name: ',
      follower_count: 'User Followers: ',
      friends_count: 'User friends: ',
      following_count: 'User following: ',
      favourites_count: 'User Favourites: ',
      reproductions_count: 'Reproductions: ',
      statuses_count: 'User Statuses: ',
      entities_url: 'URL entities: ',
      url: 'URL: ',
      lang: 'Language: '
    },
    dialog: {
      alert: {
        title: 'Warning',
        text: 'Please add search conditions',
        confirm: 'OK'
      }
    },
    sitebar: {
      title: 'Description:',
      description:
        'The "PlayGround" section is an interactive environment that allows users to test and experiment with various query combinations and filters before committing to an API call configuration. It empowers users to craft the most efficient queries based on their needs.',

      sub_title_01: 'Key Features:',
      sub_description_01: '',

      li_01_title_01: 'Live Results:',
      li_01_text_01:
        "As users adjust search parameters, they'll see real-time results. This immediate feedback helps validate the quality and quantity of data they can expect from their configurations.",

      li_01_title_02: 'Result Counter:',
      li_01_text_02: 'A dynamic count is displayed, offering users a projection of the volume of data they might be downloading daily from the API calls.',

      li_01_title_03: 'End Point Display:',
      li_01_text_03:
        'As the optimal configuration is built, a URL like https://api.trawlingweb.com/?token=YOUR_TOKEN&q=QUERY is generated. This can be referred to as the "End Point" and will be crucial for users to incorporate into their systems for subsequent API calls.',

      sub_title_02: 'PlayGround Configuration Options:',
      sub_description_02: 'Within the "PlayGround" section, users have the ability to fine-tune their search parameters based on two primary configuration types:',

      /*  ------------- */
      li_subtitle_01_01: 'APIs that Function by Search Request:',
      li_subtext_01_01: '',

      li_subli_title_01_01: 'Included APIs:',
      li_subli_text_01_01: 'News API, YouTube API, and Legal API.',

      li_subli_title_01_02: 'Configuration:',
      li_subli_text_01_02:
        'Users can craft combinations using Boolean search queries and apply filters leveraging the LUCENE syntax. This offers a powerful and precise means to access specific data points within these APIs.',

      li_subli_title_01_03: 'Tip:',
      li_subli_text_01_03: 'Familiarize yourself with LUCENE syntax to extract the most relevant results.',

      /*  ------------- */
      li_subtitle_02_01: 'APIs that Use Workers:',
      li_subtext_02_01: '',

      li_subli_title_02_01: 'Descripción:',
      li_subli_text_02_01:
        "For social media platforms, such as API Instagram, API Facebook, or API Twitter, where the data scraping is based on workers, search options aren't configurable in real-time within the PlayGround. Instead, users can only list and view the content returned based on the previously set worker configuration.",

      li_subli_title_02_02: 'Importance:',
      li_subli_text_02_02: 'This method ensures that users verify the quality and quantity of results their workers yield before making live calls.',

      li_subli_title_02_03: 'Workers:',
      li_subli_text_02_03: 'Regularly review and adjust your worker configurations to ensure optimal results.',

      /*  ------------- */
      tips_title: 'Consejos:',
      tips_description_01:
        'Utilize the PlayGround to refine your search parameters until you achieve the desired volume and quality of results for your needs. Remember, the more precise your query, the more relevant your results.',
      tips_description_02: 'For more information on the configuration and use of TrawlingWeb APIs, please refer to the "Documentation" section located in the top menu.'
    }
  },
  shop: {
    title: 'Shop',
    title_ondemand: 'Products on demand',
    title_adhoc: 'Your ADHOC product',
    step1: 'Step 1: Select product',
    step2: 'Step 2: Select mensual request',
    characteristics: 'Characteristics',
    request_remaining: 'request remaining',
    title_not_admin: 'The service will remain free until June.',
    service: 'Service',
    buy: 'Next',
    req_month: 'Request/M',
    price_month: 'Price/M',
    results: 'Total results',
    dialog: {
      same: {
        title: 'Warning',
        text: 'You already have this product.',
        confirm: 'OK'
      },
      developer: {
        title: 'Warning',
        text: 'You go to developer account.',
        confirm: 'Confirm downgrade',
        cancel: 'Cancel'
      },
      downgrade: {
        title: 'Warning',
        text: 'You making a downgrade to "{product_name}".',
        confirm: 'Confirm downgrade',
        cancel: 'Cancel'
      }
    }
  },
  consumer: {
    request: 'Request remaining from',
    workers: 'Workers',
    nextmonth: 'Next month reset:',
    token: 'Token',
    title_digital: 'News',
    title_newspro: 'News Pro',
    title_youtube: 'YouTube',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_law: 'Legal',
    upselling: 'Upgrade',
    token_copy: 'Copied token',
    close: 'Close',
    upgrade: 'Upgrade requested. We will get in touch'
  },
  documentation: {
    title: 'Description',
    subtitle: 'Technical documentation',
    sitebar: {
      title: 'Description:',
      description:
        "This section is pivotal for users aiming to deepen their understanding and proficiency with TrawlingWeb. Here, you'll find comprehensive guides, tutorials, and practical examples that will empower you to harness the full potential of our platform's features and tools. Whether you're new to the world of APIs or an adept, our documentation is curated to provide you with the insights you need at every stage of your journey with TrawlingWeb.",

      tips_title: 'Tip:',
      tips_description:
        'We advise going through this section before diving into advanced queries or configurations. The documentation serves as an invaluable reference that can save you time and effort.'
    }
  },
  usereditor: {
    title: 'User editor',
    consumer_info: 'Consumer info',
    dialog: {
      confirm: {
        title: 'Confirmation',
        text: 'Information updated',
        confirm: 'OK'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes.',
        confirm: 'OK'
      }
    },
    latest: 'Latest 10 Request',
    token: 'Service',
    graphic: 'Monthly requests',
    orders: 'Orders',
    workers_stats: 'Workers Stats'
  },
  language: {
    title: 'Language'
  },
  exit: {
    title: 'Exit'
  },
  settings: {
    title: 'Settings',
    title_user: 'User settings',
    terms_title: 'Accepted terms and conditions',
    terms_text: 'Terms and conditions.',
    privacy_text: 'Privacity policy.',
    delete_account_title: 'Delete account',
    delete_account: 'Delete account now!',
    dialog_delete: {
      title: 'WARNING',
      message: 'You are about to delete your account. You will lose all your data and settings.',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    dialog_contract: {
      terms: 'Terms and conditions',
      privacy: 'Privacy policy',
      close: 'Close'
    },
    sitebar: {
      title: 'Description:',
      description:
        "The \"Settings\" section provides a user-centric platform where personal and organizational details can be viewed and edited. This ensures that all information tied to the user's account is both current and accurate. Here's what's contained within.",

      sub_title_01: 'Key Points:',
      sub_description_01: '',

      li_01_title_01: 'User Editor:',
      li_01_text_01: 'An interface allowing the user to make necessary changes to their profile.',

      li_01_title_02: 'Mail:',
      li_01_text_02: 'The primary email address associated with the account, which is crucial for communication and notifications.',

      li_01_title_03: 'First Name & Last Name:',
      li_01_text_03: 'Essential personal identifiers, ensuring that communications and interactions are personalized.',

      li_01_title_04: 'Organization:',
      li_01_text_04: 'The name of the company or entity the user is affiliated with, useful for billing and organizational purposes.',

      li_01_title_05: 'Phone:',
      li_01_text_05: 'A contact number for direct communication or account-related queries.',

      li_01_title_06: 'ID Card or Organization VAT:',
      li_01_text_06: 'unique identifier, essential for tax, billing, and verification purposes.',

      li_01_title_07: 'Address Details:',
      li_01_text_07: 'Including the street, postal code, city, and country, necessary for billing and shipping.',

      li_01_title_08: 'Language:',
      li_01_text_08: 'Preferred language setting for the dashboard, ensuring a comfortable user experience.',

      li_01_title_09: 'Promo Code:',
      li_01_text_09: 'An optional field where users can input promotional codes for discounts or special offers.'
    }
  },
  usermanager: {
    title: 'User Manager'
  },
  billing: {
    title: 'Billing',
    id: 'Id',
    user: 'User',
    consumer: 'Consumer',
    firstname: 'Firstname',
    lastname: 'Lastname',
    billing_type: 'Type',
    billing_date: 'Billing date',
    product_type: 'Product Type',
    product_name: 'Product Name',
    price: 'Total price',
    view_order: 'View Order',
    view_invoice: 'View Invoice',
    city: 'City',
    web: 'Web payment',
    autorenew: 'Auto Renew',
    manual: 'Direct payment',
    transaction_type: 'Transaction type',
    country: 'Country',
    order: 'Order',
    invoice: 'Invoice',
    status: {
      title: 'Status',
      inactive: 'Inactive',
      active: 'Active',
      block: 'Block'
    },
    no_data: 'No data avalaible'
  },
  order: {
    order_num: 'Order number:',
    billing_date: 'Billing date: ',
    base_price: 'Base price',
    total_price: 'Total',
    taxes: 'Taxes ',
    print: 'Print Order'
  },
  invoice: {
    invoice_num: 'Invoice number:',
    billing_date: 'Billing date:',
    base_price: 'Base price',
    total_price: 'Total',
    taxes: 'Taxes',
    print: 'Print Invoice'
  },
  userform: {
    mail: 'Mail',
    password: 'Password',
    firstname: 'First Name',
    lastname: 'Last Name',
    company: 'Organitzation',
    id_card: 'ID Card or Organitzation VAT',
    address: 'Address',
    phone: 'Phone',
    postal_code: 'Postal Code',
    city: 'City',
    country: 'Country',
    language: 'Language',
    promo_code: 'Promo Code',
    vatbutton: {
      validate: 'VALIDATE VAT',
      ok: 'VALID VAT!',
      ko: 'NO VALID VAT. RETRY!'
    },
    button: {
      confirm: 'Confirm personal information',
      change: 'Save changes',
      cancel: 'Cancel'
    },
    dialog: {
      confirm: {
        title: 'Confirmation',
        text: 'Your personal information is updated',
        confirm: 'OK'
      },
      invaliddata: {
        title: 'Invalid data',
        text: 'Please complete your information.',
        confirm: 'OK'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes.',
        confirm: 'OK'
      },
      warning: {
        title: 'Warning',
        text: 'These data will be used for your billing. They must be real.',
        confirm: 'Confirm values',
        cancel: 'Cancel'
      }
    },
    rules: {
      password_required: 'Minimum 8 alphanumeric characters',
      mail_required: 'E-mail is required',
      mail_valid: 'E-mail must be valid',
      firstname_required: 'First name is required',
      lastname_required: 'Lastname is required',
      lastname_valid: 'Lastname must be valid',
      id_card_required: 'ID Card is required',
      id_card_valid: 'ID Card must be valid',
      address_required: 'Address is required',
      address_valid: 'Address must be valid',
      postal_code_required: 'Postal Code is required',
      postal_code_valid: 'Postal Code must be valid',
      city_required: 'City is required',
      city_valid: 'City must be valid',
      country_required: 'Country is required'
    }
  },
  validate_settings: {
    title: 'Validate settings'
  },
  confirm: {
    title: 'Transaction confirmation',
    ok: {
      title: 'The transaction has been successful.',
      message: 'Access your product in your "dashboard".',
      button: 'Return to dashboard'
    },
    ko: {
      title: 'The payment has been canceled or the card has been rejected.',
      button: 'Return to shop'
    },
    info: {
      title: 'Order request not found',
      button: 'Return to dashboard'
    }
  },
  confirm_ondemand: {
    title: 'Transaction confirmation',
    ok: {
      title: 'The transaction has been successful.',
      message: 'Access your product in your "dashboard".',
      button: 'Return to dashboard'
    }
  },
  downgrade: {
    title: 'Transaction confirmation',
    loading: 'Processing your order',
    confirm: 'Your account is downgraded to "{product_name}" type.',
    problem: 'Problem downgrading account, please try later.',
    button: 'Return to dashboard'
  },
  shopcart: {
    request: 'Monthly requests',
    title: 'Step 3: Checkout',
    checkout: 'Checkout',
    cancel: 'Cancel',
    order: 'Order'
  },
  workers: {
    title: 'Workers config',
    subtitle: 'Manage Workers',
    title_status: 'Workers used',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_newspro: 'News Pro',
    status_start: 'Working',
    status_stop: 'Paused',
    worker: 'worker',
    captures: 'Query posts',
    worker_id: 'Worker ID',
    info: 'Request information from our social network tracking services.',
    more: 'Request more Workers to configure tracking on social networks.',
    email: 'support@trawlingweb.com',
    telefon: '‎+34 684 38 84 66',
    status_update: 'Workers updated',
    sitebar: {
      instagram: {
        title: 'Description:',
        description: "This section is dedicated to managing and viewing the workers you've set up for Instagram monitoring.",

        sub_title_01: 'Key Points:',
        sub_description_01: '',

        li_01_title_01: 'Worker Icons:',
        li_01_text_01: 'Representing each configured worker for Instagram. The icon, such as developer_board, indicates an active worker.',

        li_01_title_02: 'Platform:',
        li_01_text_02: 'Here, the workers are always set for the Instagram platform.',

        li_01_title_03: 'Client Name & Purpose:',
        li_01_text_03: 'Describes who the client is and the specific subject or branch being monitored on Instagram.',

        li_01_title_04: 'Worker ID:',
        li_01_text_04: 'A unique identifier for each worker.',

        li_01_title_05: 'Query posts:',
        li_01_text_05: 'Links to view the specific posts scraped by the worker on Instagram.',

        li_01_title_05: 'Words:',
        li_01_text_05: 'Keywords defined by the user that the worker uses for scraping content on Instagram.',

        sub_title_02: 'Adding a New Worker:',
        sub_description_02: 'To monitor more keywords on Instagram.',
        li_02_text_01: 'Select the Instagram platform from the upper menu.',
        li_02_text_02: 'Click on "ADD WORKER".',
        li_02_text_03:
          "Set up and input your desired keywords for this new worker. Note: Remember, for Instagram, you can only add keywords that are accepted by the platform's search syntax. This includes words with # and mentions or users preceded by @.",

        tips_title: 'Tips:',
        tips_description: '',
        li_tips_01: 'Regularly update your keywords to ensure you capture all relevant content on social media platforms.',
        li_tips_02: 'For more information on the configuration and use of the workers for each TrawlingWeb API, please refer to the "Documentation" section located in the top menu.'
      },
      facebook: {
        title: 'Description:',
        description: "This section is dedicated to managing and viewing the workers you've set up for Facebook monitoring.",

        sub_title_01: 'Key Points:',
        sub_description_01: '',

        li_01_title_01: 'Worker Icons:',
        li_01_text_01: 'Representing each configured worker for Facebook. The icon, such as developer_board, indicates an active worker.',

        li_01_title_02: 'Platform:',
        li_01_text_02: 'Here, the workers are always set for the Facebook platform.',

        li_01_title_03: 'Client Name & Purpose:',
        li_01_text_03: 'Describes who the client is and the specific subject or branch being monitored on Facebook.',

        li_01_title_04: 'Worker ID:',
        li_01_text_04: 'A unique identifier for each worker.',

        li_01_title_05: 'Query posts:',
        li_01_text_05: 'Links to view the specific posts scraped by the worker on Facebook.',

        li_01_title_05: 'Words:',
        li_01_text_05: 'Keywords defined by the user that the worker uses for scraping content on Facebook.',

        sub_title_02: 'Adding a New Worker:',
        sub_description_02: 'To monitor more keywords on Facebook.',
        li_02_text_01: 'Select the Facebook platform from the upper menu.',
        li_02_text_02: 'Click on "ADD WORKER".',
        li_02_text_03:
          "Set up and input your desired keywords for this new worker. Note: For Facebook, you can add keywords that are accepted by the platform's search syntax, including words with #, mentions or users preceded by @, as well as words without # or @, since the social network's search allows it.",

        tips_title: 'Tips:',
        tips_description: '',
        li_tips_01: 'Regularly update your keywords to ensure you capture all relevant content on social media platforms.',
        li_tips_02: 'For more information on the configuration and use of the workers for each TrawlingWeb API, please refer to the "Documentation" section located in the top menu.'
      },
      twitter: {
        title: 'Description:',
        description: "This section is dedicated to managing and viewing the workers you've set up for Twitter monitoring.",

        sub_title_01: 'Key Points:',
        sub_description_01: '',

        li_01_title_01: 'Worker Icons:',
        li_01_text_01: 'Representing each configured worker for Twitter. The icon, such as developer_board, indicates an active worker.',

        li_01_title_02: 'Platform:',
        li_01_text_02: 'Here, the workers are always set for the Twitter platform.',

        li_01_title_03: 'Client Name & Purpose:',
        li_01_text_03: 'Describes who the client is and the specific subject or branch being monitored on Twitter.',

        li_01_title_04: 'Worker ID:',
        li_01_text_04: 'A unique identifier for each worker.',

        li_01_title_05: 'Query posts:',
        li_01_text_05: 'Links to view the specific posts scraped by the worker on Twitter.',

        li_01_title_05: 'Words:',
        li_01_text_05: 'Keywords defined by the user that the worker uses for scraping content on Twitter.',

        sub_title_02: 'Adding a New Worker:',
        sub_description_02: 'To monitor more keywords on Twitter.',
        li_02_text_01: 'Select the Twitter platform from the upper menu.',
        li_02_text_02: 'Click on "ADD WORKER".',
        li_02_text_03:
          "Set up and input your desired keywords for this new worker. Note: For Twitter, you can add keywords that are accepted by the platform's search syntax, including words with #, mentions or users preceded by @, as well as words without # or @, since the social network's search allows it.",

        tips_title: 'Tips:',
        tips_description: '',
        li_tips_01: 'Regularly update your keywords to ensure you capture all relevant content on social media platforms.',
        li_tips_02: 'For more information on the configuration and use of the workers for each TrawlingWeb API, please refer to the "Documentation" section located in the top menu.'
      }
    }
  },
  workers_add: {
    bt: 'Add Worker',
    title: 'Add Worker',
    description: "Worker's name",
    word: 'Word to search',
    bt_add: 'Add',
    bt_sample: 'Examples: #blue    @john    The white house',
    bt_sample_fb: 'Examples: #blue    @john    The white house',
    required: '* Indicates required field',
    close: 'Close',
    save: 'Save',
    gestion: ' Workers Manage',
    alert_1: 'Add Worker name',
    alert_2: "Very long worker's name",
    alert_3: 'Add search word',
    alert_4: 'The first character must be a # or @',
    alert_5: 'Very short word',
    alert_6: 'Inappropriate character'
  },
  workers_delete: {
    title: 'Delete Worker',
    alert: '¡¡¡Atention!!!',
    text: "It will delete both the Worker's configuration and its stored Posts.",
    text_2: 'Are you sure? Once the Worker is deleted, it can not be recovered.',
    close: 'Close',
    save: 'Save'
  },
  shop_ondemand: {
    info: {
      0: 'Increase your subscription only once without altering the monthly commitment.',
      1: 'The increase will be available until the end of the current billing cycle.'
    }
  },
  requests_selector: {
    increase: 'Increase'
  }
}
